import React from "react";
import Input from "shared/component/inputFields";
import Background from "shared/assets/images/svg/location.svg";
import Back from "shared/assets/images/svg/back_blue.svg";

import { useCustomerSignup } from "auth/signUp/signup-customer/signup-customer.service";
import { localize } from "shared/helpers/utils";
import FileUploader from "shared/component/file-upload/file-uploader";
import CheckMailBox from "auth/signUp/component/checkMailBox";
import { Trans, useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";


const CompanyLocation = (props) => {
  const {t} = useTranslation();
  const { submit, locationForm, customerSignupData,isCheckMailBoxShown ,isLoading} = useCustomerSignup();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue
  } = locationForm;

  const next = (data) => {
    submit({ ...customerSignupData, ...data });
  };

  return (
    <form className="row justify-content-between" onSubmit={handleSubmit(next)}>
      <div className="col-lg-5 col-md-6">
        <div className="page-info">
          <img className="background" src={Background} alt="img" />
          <h1 className="title"> {t('signup.location')}</h1>
          <p className="p-content">
            {t('signup.location-detail')}
          </p>
          <ul className="info-steps list-unstyled">
            <Trans i18nKey='signup.location-detail-list'>
            <li>Add the company's address in detail by choosing the region and city</li>
            <li>Describe the job title of the person in charge of the company</li>
            <li>Don't forget to add a photo of each of the mentioned documents for verification</li>
            </Trans>
          </ul>
        </div>
      </div>
      <div className="col-lg-6 col-md-6">
        <div className="box-form">
          <div className="page-header">
            <div className="header-info">
              <button onClick={props.previousStep} className='border-0'>
                <img src={Back} alt="" />
              </button>
              <h1 className="title">{t('signup.company-location')}</h1>
            </div>
          </div>
          <Input
            require
            type="text"
            label={t('signup.city')}
            {...register("city")}
            error={errors.city?.message}
          />
          <Input
            type="text"
            label={t('signup.job-description')}
            require
            {...register("employeeJobDescription")}
            error={errors.employeeJobDescription?.message}
          />
          <h1 className="box-title mb-5">{t('signup.company-info')}</h1>
          <p className="box-info ">
            {t('signup.registration-pending')}
          </p>
          <Input
            type="text"
            label={t('signup.commercial-register')}
            require
            {...register("commercialRegister")}
            error={errors.commercialRegister?.message}
          />
          <Input
            type="text"
            label={t('signup.vat-number')}
            require
            {...register("vatNumber")}
            error={errors.vatNumber?.message}
          />
          <div className="row">
            <div className="col-md-6">
              <FileUploader
                modalTitle="Upload Commercial Register"
                label={t('signup.commercial-register')}
                name="CommercialRegisterFile"
                onFileSubmit={(file) => setValue("CommercialRegisterFile", file)}
              />
            </div>
            <div className="col-md-6">
              <FileUploader
                modalTitle="Upload Vat Number"
                label={t('signup.vat-number')}
                name="VatNumberFile"
                onFileSubmit={(file) => setValue("VatNumberFile", file)}
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-6 col-md-6">
              <button disabled={isLoading} className="btn-blue w-100" type="submit">
                <Spinner animation='border' size='sm' hidden={!isLoading} />
                {t('signup.title')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CompanyLocation;
